export type SMEFormValues = {
    companyName: string;
    kbis: File[];
    insee: File[];
    registrationCertificate: File[];
    email?: string;
};

export const initialValues: SMEFormValues = {
    companyName: '',
    kbis: [],
    insee: [],
    registrationCertificate: [],
};
